import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseStatistic, GameHockeyPosition, Sport, TeamUserRole } from '@mtgame/core';
import { getHockeyStatisticHeader } from '@utils/statistic/hockey';
import { StatisticPlayerIdentity } from '../statistic-table/statistic-table.component';

@Component({
  selector: 'mtg-hockey-statistic-table-grouped',
  templateUrl: './hockey-statistic-table-grouped.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HockeyStatisticTableGroupedComponent implements OnChanges {
  @Input()
  sport: Sport;
  @Input()
  statistic: BaseStatistic[];
  @Input()
  pageSize = 1000;
  @Input()
  teamLogoVisible = true;
  @Input()
  identity: StatisticPlayerIdentity;
  @Input()
  sortByForward: string;
  @Input()
  sortByDefender: string;
  @Input()
  sortByGoalkeeper: string;
  @Input()
  checkNewbie = true;

  forwards: BaseStatistic[] = [];
  defenders: BaseStatistic[] = [];
  goaltenders: BaseStatistic[] = [];

  statisticHeader = getHockeyStatisticHeader(false);
  goalieStatisticHeader = getHockeyStatisticHeader(true);

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.statistic) {
      return;
    }
    this.forwards = [];
    this.defenders = [];
    this.goaltenders = [];
    const invalidRoles = [TeamUserRole.manager, TeamUserRole.head_manager, TeamUserRole.executive, TeamUserRole.press_attache, TeamUserRole.vice_president, TeamUserRole.president, TeamUserRole.coach, TeamUserRole.head_coach, TeamUserRole.moderator, TeamUserRole.admin, TeamUserRole.assistant_coach, TeamUserRole.senior_coach, TeamUserRole.serviceman];
    this.statistic.forEach(item => {
      if (item.tournamentTeamUser && invalidRoles.indexOf(item.tournamentTeamUser.teamUser.role) > -1) {
        return;
      }
      if (item.teamUser && invalidRoles.indexOf(item.teamUser.role) > -1) {
        return;
      }
      let position: GameHockeyPosition;
      if (this.identity === 'leaguePlayer') {
        position = item.leaguePlayer?.user?.hockeyProfile?.position;
        if (!position && item.newbie) {
          position = item.tournamentTeamUser?.teamUser?.user?.hockeyProfile?.position;
        }
      } else if (this.identity === 'teamUser') {
        position = item.teamUser.user.hockeyProfile.position;
      } else if (this.identity === 'tournamentTeamUser') {
        position = item.tournamentTeamUser.leaguePlayer.user.hockeyProfile.position;
      }
      if (position === GameHockeyPosition.forward || !position) {
        this.forwards.push(item);
      }
      if (position === GameHockeyPosition.defensemen) {
        this.defenders.push(item);
      }
      if (position === GameHockeyPosition.goaltender) {
        this.goaltenders.push(item);
      }
    });
  }

  getStatisticHeader(goalie = false) {
    return goalie ? this.goalieStatisticHeader : this.statisticHeader;
  }
}
